module.exports = __webpack_public_path__ + "static/media/green.8e8d3372.jpg";